import moment from "moment";

function DateToString(date) {
    let temp = date === null ? null : moment(new Date(date)).format("l");

    return temp;
}

export default DateToString;